import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { getAnnualReports, selectAnnualReports, selectLoadingState } from '../slice'
import AnnualReportsTable from './AnnualReportsTable'
import useCustomerNumber from '../../../../hooks/useCustomerNumber'

const AnnualReports = () => {
  const dispatch = useAppDispatch()
  const customerNumber = useCustomerNumber()
  const annualReports = useAppSelector(selectAnnualReports)
  const loadingState = useAppSelector(selectLoadingState)

  useEffect(() => {
    const needsData = customerNumber && !annualReports && loadingState.annualReports === 'not-asked'

    if (needsData) {
      dispatch(getAnnualReports(customerNumber))
    }
  }, [customerNumber, annualReports, loadingState.annualReports])

  return (
    <>
      {annualReports && annualReports.length > 0 && (
        <AnnualReportsTable
          customerNumber={customerNumber}
          annualReports={annualReports}
        />
      )}
      {loadingState.annualReports === 'done' && (!annualReports || annualReports.length === 0) && (
        <div className='p-16 center'>
          You have no annual Biological Monitoring reports at this time. This section displays
          annual reports summarizing your Biological Monitoring. To receive this report you can either: log your test results
          in the Biological Monitoring area of OnTraq or use our HealthFirst Mail-In product to have test results automatically
          displayed.
        </div>
      )}
    </>
  )
}

export default AnnualReports